import { createFileRoute } from "@tanstack/react-router";
import Methodik from "@/pages/Methodik";

const title = "Methodik: So vergleichen wir Kreditkarten | Kreditkarten.de";
const description =
  "Woher unsere Kartendaten stammen, wie wir Karten einordnen und sortieren, wie oft wir prüfen und wie wir Geld verdienen – transparent erklärt.";
const url = "https://www.kreditkarten.de/methodik";

export const Route = createFileRoute("/methodik")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: url },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: url }],
  }),
  component: Methodik,
});
